import { useState } from 'react';
import { useBaseSearchQuery } from 'api/base/useBaseSearchQuery';
import { IReview, ISearchReviewsInput } from 'types/types';
import { reviewQueries } from '../../../api/review';

export const useSearchReviews = () => {
  const [filter, setFilter] = useState({} as ISearchReviewsInput);
  const { onSearch, onChangePage, page, totalItems, totalPages, items, loading } = useBaseSearchQuery<
    ISearchReviewsInput,
    IReview
  >({
    fetchPolicy: 'cache-and-network',
    query: reviewQueries.SEARCH,
  });

  const onSearchReviews = (input: ISearchReviewsInput) => {
    onSearch(input);
    setFilter(input);
  };

  const onRefresh = () => {
    onSearch(filter);
  };

  return {
    page,
    totalItems,
    totalPages,
    loading: loading,
    reviews: items,
    onChangePage,
    onSearchReviews,
    onRefresh,
  };
};
